import React, { Component,useEffect,useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../../config.js'
import DataTable,{defaultThemes} from 'react-data-table-component';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import HTMLParserComponent from "../../HTMLParserComponent.js"

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import '../../preloading.css';




import {
	statisticsAction,
	statisticsCloseAction
} from '../../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const MenuControl = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;

	// function getDate() {
	// 	const today = new Date();
	// 	const month = today.getMonth() + 1;
	// 	const year = today.getFullYear();
	// 	const date = today.getDate();
	// 	return `${year}-${month}-${date}`;
	//   }

	const today = new Date().toISOString().split("T")[0];


	const [user, setUser] = useState({
        start_date: today,
        end_date: today,
        shift_id:"ALL",
    })



	

	
	const history = useHistory();
	const [data, setData]= useState([]);
	const [dataval, setdataval]= useState([]);
    const [isVisible, setIsVisible] = useState(false);
	const [urlres, setUrlRes] = useState(false);
	const [style1,setStyle1]=useState(false);
	const [records, setRecords] = useState([]);
	const [loading, setLoading] = useState(false);
	const cleanHTML = (str) => str.replace(/<[^>]+>/g, ''); // remove HTML tags


    const handelInput = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });

        if (event.target.value === '1') {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
    }


	const [searchTerm, setSearchTerm] = useState("");
		const [currentPage, setCurrentPage] = useState(1);
		const [itemsPerPage, setItemsPerPage] = useState(10);
		const indexOfLastItem = currentPage * itemsPerPage;
		const indexOfFirstItem = indexOfLastItem - itemsPerPage;
		let filteredItems = records.filter((item) =>
    `${item.shift_date.toLowerCase()}${cleanHTML(item.shift_name).toLowerCase()}${cleanHTML(item.status).toLowerCase()}`
        .includes(searchTerm.toLowerCase())
);

		const filteredData = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
		const startIndex = (currentPage - 1) * itemsPerPage;
	  
		useEffect(() => {
		  setCurrentPage(1);
		}, [searchTerm]);
	  
		const paginate = (pageNumber) => setCurrentPage(pageNumber);
	
	  const handleSearch = (event) => {
		//console.log(event.target.value);
		 setSearchTerm(event.target.value);
	  };
	
	  const handleRowsPerPageChange = (e) => {
		setItemsPerPage(Number(e.target.value));
		setCurrentPage(1); // Reset to first page
	  };





  useEffect(()=> {
	axios.get(API_BASE_URL +'/fetchshift', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

	//.then(res =>console.log(res.data))
	 .then(res => setData(res.data))
	.catch(err => console.log(err));
},[])






const handleSubmit = async (e) => {
    e.preventDefault();
	setLoading(true);
    try {
      const response = await axios.post(API_BASE_URL +'/myshift',
		{ start_date: user.start_date, end_date: user.end_date, shift_id: user.shift_id }, 
		{
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}

);
    //  console.log(response.data.calendar);
      setRecords(response.data.calendar); // Assuming the API response contains the records in `response.data`
	  setLoading(false);
	} catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  useEffect(()=> {
	axios.post(API_BASE_URL +'/myshift',{ start_date: user.start_date, end_date: user.end_date, shift_id: user.shift_id }, {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

	//  .then(response =>console.log(response.data.calendar))
	 .then(response => setRecords(response.data.calendar))
	.catch(err => console.log(err));
},[])


	return (
		<>
			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

						<ToastContainer/>
							

						</div>


						
					</div>


                    <div className="section-body mt-3">
					<div className="container-fluid">
						<div className="row clearfix">
							<div className="col-md-12">
								<div className="card">
									{/* <div className="card-header">
										<h3 className="card-title">My Shift</h3>
									</div> */}
									<div className="card-body">
										 <form onSubmit={handleSubmit}> 

                                            <div class="row">

											<div className="col-md-2 col-sm-6">
												<div className="form-group">
												<input type="date" className="form-control" name="start_date" value={user.start_date}
								onChange={handelInput} placeholder="Start Date" />
												{/* <DatePicker
												// selected={start_date}
												// value={start_date}
												name="start_date"
												onChange={handelInput}
												//onChange={(date) => setSelectedDate(date)}
												dateFormat="yyyy-MM-dd"
												isClearable
												placeholderText="Start Date"
											/> */}
											{/* {selectedDate && <p>Selected Date: {selectedDate.toDateString()}</p>} */}
												</div>
											</div>

											<div className="col-md-2 col-sm-6">
												<div className="form-group">
												<input type="date" className="form-control" name="end_date" value={user.end_date}
								onChange={handelInput} placeholder="End Date" />
												{/* <DatePicker
												// selected={end_date}
												// value={}
												onChange={handelInput}
												//onChange={(date) => setSelectedDate(date)}
												dateFormat="yyyy-MM-dd"
												isClearable
												placeholderText="End Date"
											/>*/}
											{/* {selectedDate && <p>Selected Date: {selectedDate.toDateString()}</p>} */}
												</div>
											</div> 

                                            {/* <div className="col-md-2 col-sm-6">
									<div className="form-group">
										<input type="text" className="form-control" name="menu_icon" value={user.menu_icon}
								onChange={handelInput} placeholder="Menu Icon" />
									</div>
								</div> */}

                                

                                    {/* <div className="col-md-2 col-sm-6">
									<select name="shift_id" id="shift_id" className="form-control custom-select" value={user.shift_id} onChange={handelInput}>
										<option value="" disabled>Select Shiftcode</option>
											<option value="all">ALL</option>
											{data.map(option => (
											<option key={option.office_shift_id} value={option.office_shift_id}>
												{option.shift_name}
											</option>
											))}
										</select>
                                    </div> */}
                                    
							

								
								


                                <div className="col-md-4 col-sm-6">
									<div className="form-group">

                                <button type="submit" className="btn btn-primary">
								GET
							</button>

							<Link to={`/attendancecalendar`} className="btn btn-primary" style={{marginLeft :"1rem"}}>Calendar View</Link>

							
                            </div>
                            </div>



							{/* <div className="col-md-2 col-sm-6">
									<div className="form-group">

                               

							<Link to={`/attendancecalendar`} className="btn btn-primary">Attendance Calendar</Link>

                            </div>
                            </div> */}


                            </div>

                            
                               

                                           


										
	
										
											
										 </form>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>




					<div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
									<div className="card">

										<div className="card-header">
											<h3 className="card-title" style={{color:'#e96827'}}>My Shift</h3>
											<div className="card-options">
												<form>
													<div className="input-group">
													<select style={{
																padding: '8px',
																marginRight: '20px',
																borderRadius: '4px',
																border: '1px solid #ccc',
																backgroundColor: '#BCD1DB',display: 'flex', justifyContent: 'left'
															  }}
														id="rowsPerPage"
														value={itemsPerPage}
														onChange={handleRowsPerPageChange}
													>
														<option value={10}>10</option>
														<option value={25}>25</option>
														<option value={50}>50</option>
														<option value={100}>100</option>
													</select> 
													
														 <input
															type="text"
															className="form-control form-control-sm"
															placeholder="Search"
															value={searchTerm}
															onChange={handleSearch} style={{ padding: '8px', width: '200px', borderRadius: '4px', border: '1px solid #ccc' }} 
														/>
													</div>
												</form>
											</div>
										</div>

										{/* <div>
											<DataTable 
											columns={column} 
											data={data}
											customStyles={customStyles}
											pagination 
											highlightOnHover
											responsive
											paginationPerPage={10}
											paginationRowsPerPageOptions={[25,50,100,500]}
											className="table table-striped table-bordered"> 
										</DataTable>
										</div> */}







{/* Loading Spinner */}
{loading && (
											<div className="card-body">
											<div class="d-flex justify-content-center">
       <div class="spinner"></div>
	   </div>
	   </div>
      )}

{!loading && (
										<div className="card-body">
										
											<div className="table-responsive">
		

    
      
			<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
													<thead>
														<tr>

															<th>Emp Id</th>
															<th>Employee Name</th>
															<th>Shift Date</th>
															<th>Shift Name</th>
															<th>Punch In</th>
															<th>Punch out</th>
															<th>Status</th>
															
														</tr>
													</thead>
													<tbody>
													{records.length > 0 ? (
															filteredData.map((record) => (
															<tr key={record.employee_id}>
																<td>{record.employee_id}</td>
																<td>{record.emp_name}</td>
																<td>{record.shift_date}</td>
																<td>{ReactHtmlParser(record.shift_name)}</td>
																<td>{ReactHtmlParser(record.punch_in)}</td>
																<td>{ReactHtmlParser(record.punch_out)}</td>
																<td>{ReactHtmlParser(record.status)}</td>
															</tr>
															))
														) : (
															<tr>
															<td colSpan="7" style={{ color: 'red', textAlign: 'center',fontWeight: "bold" }}>No records found</td>
															</tr>
														)}

											
													</tbody>
												</table>
											</div>
										
			<nav aria-label="Page navigation">
				<ul className="pagination mb-0 justify-content-end">
				<li className="page-item"><button className="page-link"
                key={'f'}
                onClick={() => paginate(1)}
              >
                First
              </button></li>
										
          {Array.from(
            { length: Math.ceil(filteredItems.length / itemsPerPage) },
            (_, index) => (
				<li className="page-item">
              <button className="page-link"
                key={index + 1}
                onClick={() => paginate(index + 1)}
              >
                {index + 1}
              </button></li>
            )
          )}

			<li className="page-item">
			<button className="page-link"
                key={'l'}
                onClick={() => paginate(Math.ceil(filteredItems.length / itemsPerPage))}
              >
                Last
              </button></li>

										</ul>
									</nav>	
								

										</div> 
)
}
									</div>
								</div>
	
							
							</div>
						</div>
					</div>

				</div>
			</div> 

										
			


			
			


			

		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(MenuControl);